import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
  authContent: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export default useStyles;
